export default {
  setTeamMembers(state: any, payload: any) {
    state.teamMemberList = payload;
  },
};
